<aside class="under-development-art" aria-hidden="true">
  <svg viewBox="0 0 260 300">
    <rect x="38" y="44" width="184" height="212" rx="8" fill="#ffffff" stroke="#c9d9dd" stroke-width="4" />
    <rect x="58" y="68" width="144" height="20" rx="5" fill="#dfeaec" />
    <rect x="58" y="106" width="88" height="12" rx="4" fill="#0f766e" />
    <rect x="58" y="130" width="124" height="12" rx="4" fill="#c4d4d9" />
    <rect x="58" y="154" width="96" height="12" rx="4" fill="#c4d4d9" />
    <rect x="58" y="198" width="144" height="38" rx="8" fill="#fff4df" stroke="#f0b45b" stroke-width="3" />
    <path d="M79 217h102" stroke="#d97706" stroke-width="8" stroke-linecap="round" stroke-dasharray="18 14" />
    <circle cx="198" cy="52" r="24" fill="#2563eb" />
    <path d="m187 52 8 8 16-18" stroke="#ffffff" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M80 261h100" stroke="#95aab1" stroke-width="10" stroke-linecap="round" />
    <path d="M94 257V286M166 257V286" stroke="#95aab1" stroke-width="8" stroke-linecap="round" />
    <path d="M53 284h154" stroke="#60707d" stroke-width="10" stroke-linecap="round" />
  </svg>
</aside>
